/* eslint-disable */
const init = () => {
	return `
	precision mediump float;

	// Varying (data we receive from the vertex shader)
	// varying vec2 vResolution;
	// varying float vTestValue;
	// varying vec2 vUv;
	varying vec3 vColor;
	varying float vVertexOpacity;

	void main()
	{
		// Disc pattern
		float distanceVal = distance(gl_PointCoord, vec2(0.5));

		float strength = step(0.5, distanceVal);
		vec3 finalColor = vColor * strength;

		float opacity = step(0.5, (1.0 - distanceVal));
		float finalOpacity = opacity * vVertexOpacity;

		gl_FragColor = vec4(vColor, finalOpacity);
	}
	`;
};


export default {
	init,
};
/* eslint-enable */
